/**
 * Main theme JavaScript file.
 *
 * This file is the entry point for the Webpack build process.
 * It should be used to import and initialize other JavaScript modules.
 */

// 1. Import the main SCSS file to be processed by Webpack.
import '../scss/main.scss';

// 2. Import modules/components.
// import MobileMenu from './components/MobileMenu.js';
import SmoothScroll from './components/SmoothScroll.js';

// import ExampleComponent from './components/ExampleComponent'; // Uncomment to use

/**
 * The main function to run on DOMContentLoaded.
 * This is where you initialize all your components.
 */
const main = () => {
	// Initialize the Mobile Menu component.
	// const mobileMenu = new MobileMenu( {
	// 	menuButtonSelector: '.js-mobile-menu-toggle',
	// 	menuContainerSelector: '.main-navigation', // Example selector
	// } );
	// mobileMenu.init();

	// Initialize the Smooth Scroll component.
	const smoothScroll = new SmoothScroll();
	smoothScroll.init();

	// Initialize other components here.
};

// 3. Run the main function when the DOM is ready.
// This ensures that all elements are available before your scripts try to interact with them.
if ( document.readyState === 'complete' || document.readyState === 'interactive' ) {
	main();
} else {
	document.addEventListener( 'DOMContentLoaded', main, false );
}
